module.exports = __webpack_public_path__ + "img/pix-brands-solid.6a8bd8de.svg";